import dayjs from 'dayjs';

export const useZoneService = () => {
  // Repositories
  const { getZone } = useZoneRepository();

  // Store
  const { period, energyType, areaId } = storeToRefs(exploreStore());
  const { maxDepth } = storeToRefs(zoneStore());

  const loadZoneData = async () => {
    await getZone({
      energy_type: energyType.value,
      start: dayjs(period.value.start).format('YYYY-MM-DD'),
      end: dayjs(period.value.end).format('YYYY-MM-DD'),
      max_depth: maxDepth.value,
      area_id: areaId.value,
    });
  };
  return { loadZoneData };
};
